import React from "react";

export default function AddressesPage() {
  const branches = [
    {
      id: 1,
      title: "Психологический центр БЛИЗКО — Набережная",
      address: "ул. Набережная 70‑летия СССР, 75С, офис 301 и 412",
      coords: [44.962079, 34.098889]
    },
    {
      id: 2,
      title: "Психологический центр БЛИЗКО — Киевская",
      address: "ул. Киевская, 77/4, оф.208",
      coords: [44.959177, 34.110064]
    },
    {
      id: 3,
      title: "Психологический центр БЛИЗКО — Севастопольская",
      address: "ул. Севастопольская, 43В, офис 506",
      coords: [44.928643, 34.085001]
    }
  ];

  const openMap = (coords) => {
    const url = `https://yandex.ru/maps/?ll=${coords[1]},${coords[0]}&z=16`;
    window.open(url, "_blank");
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Наши филиалы</h2>
      {branches.map((b) => (
        <div
          key={b.id}
          style={{
            padding: "15px",
            marginBottom: "15px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            background: "#fafafa"
          }}
        >
          <p style={{ margin: "0 0 8px 0" }}>{b.title}</p>
          <p style={{ margin: "0 0 12px 0", color: "#555" }}>{b.address}</p>
          <button
            onClick={() => openMap(b.coords)}
            style={{
              padding: "8px 12px",
              fontSize: "14px",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#042204ff",
              color: "#fff",
              cursor: "pointer"
            }}
          >
            Открыть на карте
          </button>
        </div>
      ))}
    </div>
  );
}
